<template>
  <div>
    <div
        class="px-4 py-2 hover:bg-gray-50 flex items-center"
        :style="{'cursor': category.expanded ? 'row-resize' : 'crosshair'}"
        @click="toggle"
    >
      <input
          type="checkbox"
          :checked="isSelected"
          @click.stop="toggleSelect"
          style="cursor: pointer"
          class="h-6 w-6 text-blue-600 focus:ring-blue-500 border-gray-300 rounded ml-2"
      >

      <div class="mr-5 ml-2">
        <img
            v-if="imageUrl && !imgFailed"
            :src="imageUrl"
            alt=""
            class="h-8 w-8 object-cover rounded border border-gray-200"
            loading="lazy"
            @error="onImgError"
        >
        <div
            v-else
            class="h-8 w-8 rounded border border-gray-300 flex items-center justify-center text-xs text-gray-500 select-none"
            aria-hidden="true"
            title="بدون تصویر"
        >!</div>
      </div>
      <span class="text-right flex-grow" v-html="highlightedName"></span>
      <span
          v-if="hasChildren"
          class="w-4 h-4 flex items-end justify-end text-gray-500"
      >
        {{ category.expanded ? '−' : '+' }}
      </span>
    </div>

    <div v-if="category.expanded && hasChildren" class="rtl mr-7">
      <category-item
          :search-query="searchQuery"
          v-for="child in category.children"
          :key="child.id"
          :category="child"
          :selected-categories="selectedCategories"
          @toggle="$emit('toggle', $event)"
          @toggle-select="$emit('toggle-select', $event)"
      />
    </div>
  </div>
</template>

<script>
export default {
  name: 'CategoryItem',
  props: {
    searchQuery: { type: String, default: '' },
    category: { type: Object, required: true },
    selectedCategories: { type: Array, default: () => [] }
  },
  data() {
    return { imgFailed: false }
  },
  computed: {
    hasChildren() { return this.category.children && this.category.children.length > 0 },
    isSelected() { return this.selectedCategories.some(c => c.id === this.category.id) },
    imageUrl() {
      const img = this.category.image
      const url = img && typeof img === 'object' ? img.url : img
      return this.img_source(url) || null
    },
    highlightedName() {
      const name = String(this.category.name || '');
      const q = (this.searchQuery || '').trim();
      if (!q) return this.escapeHtml(name);

      const rx = new RegExp(this.escapeRegExp(q), 'gi');

      const escaped = this.escapeHtml(name);

      return escaped.replace(rx, (m) => `<mark class="ps-hl">${this.escapeHtml(m)}</mark>`);
    }
  },
  methods: {
    toggle() { if (this.hasChildren) this.$emit('toggle', this.category) },
    toggleSelect() { this.$emit('toggle-select', this.category) },
    onImgError() { this.imgFailed = true },
    escapeHtml(s) {
      return String(s)
          .replace(/&/g, '&amp;')
          .replace(/</g, '&lt;')
          .replace(/>/g, '&gt;')
          .replace(/"/g, '&quot;')
          .replace(/'/g, '&#039;');
    },
    escapeRegExp(s) {
      return String(s).replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
    }
  },
  watch: {
    category: {
      handler() { this.imgFailed = false },
      deep: true
    }
  }
}
</script>
<style>
.ps-hl {
  background: linear-gradient(90deg, rgba(59,130,246,.2), rgba(59,130,246,.35));
  padding: 0 .15rem;
  border-radius: .25rem;
}
</style>
